import { get, post } from '@api/request';

export const fetchPreference = async (
  { userService },
  authenticationToken,
  { userId },
) => {
  const url = `${userService}/trueprodigy/user/${userId}/preference/assessment`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const persistPreference = async (
  { userService },
  authenticationToken,
  { userId, data },
) => {
  const url = `${userService}/trueprodigy/user/${userId}/preference/assessment`;
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export async function fetchDropdowns(
  { assessmentService },
  authenticationToken,
  { year, type, name },
) {
  let url = `${assessmentService}/appraisal/codes?type=${type}&name=${name}`;
  url += year ? `&year=${year}` : '';
  const { body } = await get(authenticationToken, url);
  return body;
}
